import React from 'react'

const LoaderContext = React.createContext({
    loading: true,
    hideLoader: () => {},
    showLoader: () => {},
});

export default LoaderContext;